import { render } from "./AskForHelp.vue?vue&type=template&id=7b2e737c&scoped=true"
import script from "./AskForHelp.vue?vue&type=script&lang=js"
export * from "./AskForHelp.vue?vue&type=script&lang=js"

import "./AskForHelp.vue?vue&type=style&index=0&id=7b2e737c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/APLM/APLM/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b2e737c"]])

export default __exports__